import AppLoading from "../../../../../commons/AppLoading";
import VisitItem from "../visits/VisitItem";
import VisitsEmptyState from "../visits/VisitsEmptyState";
import VisitsToolbar from "../visits/VisitsToolbar";
// tabs/CustomerVisitsTab.jsx
import { useRef } from "react";

export default function CustomerVisitsTab({
  isLoading,
  q,
  setQ,
  period,
  setPeriod,
  groupMode,
  setGroupMode,
  sortMode,
  setSortMode,
  filteredHistory,
  groupedHistory,
}) {
  const searchInputRef = useRef(null);

  return (
    <>
      <VisitsToolbar
        q={q}
        setQ={setQ}
        period={period}
        setPeriod={setPeriod}
        groupMode={groupMode}
        setGroupMode={setGroupMode}
        sortMode={sortMode}
        setSortMode={setSortMode}
        count={filteredHistory.length}
        searchInputRef={searchInputRef}
      />

      {isLoading ? (
        <div className="mt-3">
          <AppLoading />
        </div>
      ) : filteredHistory.length === 0 ? (
        <VisitsEmptyState title="Nenhuma visita encontrada" subtitle="Tente ajustar a busca ou os filtros." />
      ) : groupMode === "MONTH" ? (
        <div className="hc-cd-list">
          {groupedHistory.map(([month, items]) => (
            <div key={month} className="hc-cd-group">
              <div className="hc-cd-group__header">
                <span className="hc-cd-group__badge">{month}</span>
                <span className="hc-cd-group__meta">{items.length} visita(s)</span>
              </div>

              <div className="hc-cd-group__items">
                {items.map((visit, idx) => (
                  <VisitItem key={`${month}-${idx}`} visit={visit} />
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="hc-cd-list">
          <div className="hc-cd-group__items">
            {filteredHistory.map((visit, idx) => (
              <VisitItem key={`visit-${idx}`} visit={visit} />
            ))}
          </div>
        </div>
      )}
    </>
  );
}
